@if (isInitialized) {
  <ng-container class="all-edges-shadow">
    <oe-flat-widget [icon]="{name: 'oe-consumption', color: 'consumption'}" [title]="'GENERAL.CONSUMPTION' | translate"
      button [modalComponent]="modalComponent">
      <!-- Evcss -->
      @if (evcss.length > 0) {
        @for (component of evcss; track component; let i = $index) {
          <oe-flat-widget-line [name]="component.alias" [channelAddress]="component.powerChannel.toString()"
            [converter]="CONVERT_WATT_TO_KILOWATT">
          </oe-flat-widget-line>
        }
      }
      <!-- ConsumptionMeters -->
      @if (consumptionMeters.length > 0) {
        @for (component of consumptionMeters; track component) {
          <oe-flat-widget-line [name]="component.alias" [channelAddress]="component.id + '/ActivePower'"
            [converter]="CONVERT_WATT_TO_KILOWATT">
          </oe-flat-widget-line>
        }
      }
      <!-- If at least Evcss or ConsumptionMeters -->
      @if (evcss.length !== 0 || consumptionMeters.length !== 0) {
        <oe-flat-widget-horizontal-line></oe-flat-widget-horizontal-line>
        <oe-flat-widget-line [name]="'GENERAL.OTHER_CONSUMPTION' | translate" [value]="otherPower"
          [converter]="CONVERT_WATT_TO_KILOWATT">
        </oe-flat-widget-line>
      } @else {
        <oe-flat-widget-line [value]="sumActivePower" [converter]="CONVERT_WATT_TO_KILOWATT">
        </oe-flat-widget-line>
      }
      <!-- For no Evcss and ConsumptionMeters -->
    </oe-flat-widget>
  </ng-container>
}
